const KEY_SHOW_SUBMIT_TIPS = 'SHOW_SUBMIT_TIPS';
export function save(key, value){
    if(window.localStorage){
        window.localStorage.setItem(key, value);
    }
}

export function read(key){
    if(window.localStorage){
        return window.localStorage.getItem(key);
    }
    return null;
}

export function showSubmitTips() {
    const show = read(KEY_SHOW_SUBMIT_TIPS);
    return !show;
}

export function hideSubmitTips() {
    save(KEY_SHOW_SUBMIT_TIPS, true);
}